import { DownloadOutlined, ExclamationOutlined } from "@ant-design/icons";
import { Steps, Form, Input, Spin, Modal } from "antd";
import React, { forwardRef, useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import axios from "axios";
import StyledModal from "antComponents/Modal";
const { Step } = Steps;
const backend = process.env.REACT_APP_BACKEND;

const GoogleOTP = forwardRef(({ currentStep }, otpRef) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
 
  const userInfo = useSelector((state) => state.mainReducer.userInfo);

  const Step1Content = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <DownloadOutlined style={{ fontSize: "80px", marginBottom: "20px" }} />
        <div style={{ fontSize: "12px" }}>
          먼저 스마트폰에 구글인증기를 다운로드하고 설치하십시요.
          <br />
          <br />
          이미 설치되어 있거나 설치를 완료했다면 아래의 ‘다음' 버튼을 터치하여
          구글인증기와 잉글마이닝을 연결하세요.
        </div>
      </div>
    );
  };

  const Step2Content = () => {
    const [otpInfo, setOtpInfo] = useState([]);

    // console.log(otpInfo)
    function copyToClipboard () { // 카피하기
      const text = document.querySelector("#qrcode")
      text.select() //영역선택
      document.execCommand("copy") //카피
      text.setSelectionRange(0,0) //선택영역 초기화. 없으면 선택된 채로 남는다.
    }

    useEffect(() => {
      // useEffect의 필요 이유는 무한로프 때문
      // console.log('이펙트')
      if (otpInfo.length === 0) {
        axios
          .post(`${backend}/authentication/googleTOTP`)
          .then((data) => {
            // console.log(data.data);
            setOtpInfo([data.data.image_data, data.data.secretkey]);
          })
          .catch((err) => {
            console.log(err);
            // dispatch(authAction(false, null));  왜 필요??
          });
      }
    }, []);

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ textAlign: "center" }}>
          {otpInfo[0] ? 
          <img src={otpInfo[0]} alt="qr"></img>
          : <Spin size="large">
            <div style={{width:"200px", height:"200px"}}></div>
            </Spin>}
        </div>
        <div style={{ fontSize: "12px" }}>
          이 키를 안전한 장소에 보관하십시오. 이 키를 보관하고 있으면 핸드폰을
          분실하더라도 구글인증기와 잉글마이닝을 연결할 수 있습니다. <br />
          <br />
          구글인증기에서 잉글마이닝 계정을 등록하려면 위 QR코드를 촬영하거나
          아래의 코드를 복사하여 구글인증기에 입력하여 계정을 생성하세요. <br />
          <br />
          그런 다음 아래의 ‘다음' 버튼을 클릭하세요.
        </div>
        <Form>
          <Input
            id="qrcode"
            style={{ fontSize: 12 }}
            value={otpInfo[1]}
            suffix={<div onClick={copyToClipboard} style={{cursor:"pointer"}}>코드복사</div>}
          ></Input>
        </Form>
      </div>
    );
  };

  const Step3Content = forwardRef((props, otpRef) => {
    const [spinning, setSpinning] = useState(false);
    const [count, setCount] = useState(-1)

    const sendEmail = async () => {
      setSpinning(true);
      otpRef.current.resetFields(["emailCode"])
      await axios
        .post(`${backend}/authentication/email`, { email: userInfo.email })
        .then((data) => {
          setSpinning(false);
          setCount(data.data.count - 2);
          return Modal.success({title: data.data.message, okText:"확인"})
        })
        .catch((err) => {
          setSpinning(false);
          return StyledModal.error("코드전송 에러", err.response.data.message);
        });
    };

    const authCodeValidator = (_, value) => {
      const regExpCode = new RegExp(/^[0-9]{6}$/);
      if (!value) {
        return Promise.resolve();
      }
      if (regExpCode.test(value) === false) {
        return Promise.reject(new Error("인증코드 형식이 맞지 않습니다."));
      }
      return Promise.resolve();
    };


  useEffect(() => {
    if (count > 0) {
      const codeTime = setInterval(() => {
        setCount(count - 1);
      }, 1000);
      return () => {
        clearInterval(codeTime);
      };
    } else if (count === 0) {
      setCount(-1);
    }
  });

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Form ref={otpRef} validateTrigger={["onChange", "onBlur"]}>
          <Spin spinning={spinning}>
            <Form.Item
           rules={[
            {
              required: true,
              message: "이메일 인증 코드를 입력하세요."
            },
            {validator: authCodeValidator,
            validateTrigger:"onBlur"}
          ]}
          name="emailCode">
              <Input
                style={{ fontSize: 12, marginTop: 20 }}
                placeholder="이메일 인증 코드"
              suffix={
                count > 0
                ? (<div style={{ color: "red" }}>{count}</div>)
                : (<div onClick={sendEmail} style={{cursor:"pointer"}}>코드전송</div>)
                }
              ></Input>
            </Form.Item>
          </Spin>
          <Form.Item
           rules={[
            {
              required: true,
              message: "구글인증기 코드를 입력하세요."
            },
            {validator: authCodeValidator,
            validateTrigger: "onBlur"}
          ]}
          name="otpCode">
            <Input
              style={{ fontSize: 12, marginTop: 10 }}
              placeholder="구글인증기 인증 코드"
            ></Input>
          </Form.Item>
        </Form>
        <div style={{ fontSize: 12, marginTop: 10 }}>
          구글인증기에서 제시한 6자자리의 숫자를 입력하세요
        </div>
      </div>
    );
  });

  const Step4Content = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ fontSize: "12px", marginTop: "50px" }}>
          잉글마이닝과 구글인증기가 연결되어 MFA 사용이 활성화 되었습니다.
        </div>
      </div>
    );
  };


  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Steps size="small" current={currentStep}>
        <Step title="설치" />
        <Step title="복사" />
        <Step title="연결" />
      </Steps>
      <div style={{ width: "90%" }}>
        {currentStep === 0 ? (
          <Step1Content />
        ) : currentStep === 1 ? (
          <Step2Content />
        ) : currentStep === 2 ? (
          <Step3Content ref={otpRef} />
        ) : (
          <Step4Content />
        )}
      </div>
    </div>
  );
});
export default GoogleOTP;
